<template>
  <b-container>
    <b-form @submit="onSubmit" v-if="taskDetailsList.length > 0">
      <div v-if="success" class="pt-4">
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </div>
      <div v-else>
        <b-row class="mt-4" v-if="taskImageExist">
          <b-col sm="6">
            <b-img
              :src="taskImageExist"
              fluid
              alt="Fluid image"
              class="taskThumbnail"
            ></b-img>
          </b-col>
          <hr />
        </b-row>
        <b-row class="mt-4">
          <b-col sm="6">
            <div class="mb-2">{{ $t("label.taskThumbnail") }}</div>
            <b-form-file
              v-model="taskImage"
              name="taskImage"
              accept="image/*"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="taskImage"
              :placeholder="$t('action.choosefile')"
              @change="validateFile"
            ></b-form-file>
            <b-button
              @click="clearFiles()"
              size="sm"
              class="mt-3"
              :disabled="disabledClear()"
              >{{ $t("action.clearField") }}</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <div class="mt-4">{{ $t("label.description") }}</div>
            <b-form-textarea
              id="description"
              v-model="description"
              :placeholder="$t('info.description')"
              rows="4"
              max-rows="6"
              class="mt-1"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-button
          class="mt-4 text-center"
          type="submit"
          variant="success"
          :disabled="disabled"
          >{{ $t("action.submit") }}</b-button
        >
      </div>
    </b-form>
    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
    <div v-if="spinner" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["task", "taskListTable", "modalid"],
  data: () => ({
    taskImage: null,
    taskImageExist: null,
    disabled: false,
    success: false,
    error: "",
    spinner: false,
    errorList: [],
    taskDetailsList: [],
    description: "",
    errorfile1: false,
  }),
  mounted() {
    this.getAllTaskDetails();
  },
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
  },
  methods: {
    getAllTaskDetails: function () {
      this.spinner = true;
      let taskList = this.taskListTable;
      let token = this.getGlobalData("accessToken");
      let requestTaskDetails = [];

      for (let i = 0; i < taskList.length; i++) {
        let taskId = taskList[i].id;
        requestTaskDetails.push(this.getTaskDetails(token, taskId));
      }

      Promise.allSettled(requestTaskDetails).then((results) => {
        this.spinner = false;
        let successList = results.filter((r) => r.status === "fulfilled");

        if (successList.length > 0) {
          for (let i = 0; i < successList.length; i++) {
            let taskDetails = successList[i].value.data;
            this.taskDetailsList.push(taskDetails);
          }

          let firstTaskDetails = this.taskDetailsList[0]; //sert de reference pour toutes les autres taches

          this.description = firstTaskDetails.description
            ? firstTaskDetails.description
            : "";
          this.taskImageExist = this.getTaskDetailsReferences(
            firstTaskDetails.references
          );
        }

        let errorList = results.filter((r) => r.status === "rejected");
        if (errorList.length > 0) {
          this.errorList.push(errorList);
          this.logError(errorList);
        }
      });
    },
    getTaskDetailsReferences(references) {
      let refArr = [];
      for (const property in references) {
        let objectValue = references[property];
        objectValue.url = property;
        refArr.push(objectValue);
      }
      let url = null;
      if (refArr.length > 0) {
        refArr.sort((a, b) => {
          return (
            moment(b.lastModifiedDateTime).toDate() -
            moment(a.lastModifiedDateTime).toDate()
          );
        });
        url = decodeURIComponent(refArr[0].url);
      }
      return url;
    },
    getTaskDetails(token, taskId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/tasks/${taskId}/details`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setBodyTaskDetails(webUrl) {
      let body = {
        description: this.description
      };

      if (webUrl) {
        
        body.previewType = "reference";
        let encoded = this.encodedUri(webUrl);

        let references = {};
        references[encoded] = {
          "@odata.type": "microsoft.graph.plannerExternalReference",
          alias: "Lien vers l'image / Link to image",
          previewPriority: " !",
          type: "Other",
        };
        body.references = references;
      }

      return body;
    },
    encodedUri(uri) {
      const chars = {
        ".": "%2E",
        ":": "%3A",
      };
      let encoded = uri.replace(/[.:]/g, (m) => chars[m]);
      return encoded;
    },
    disabledClear: function () {
      return this.taskImage ? false : true;
    },
    clearFiles: function () {
      this.errorfile1 = false;
      this.error = "";
      this.$refs["taskImage"].reset();
      this.taskImage = null;
    },
    validateFile(event) {
      let myfile = event.target.files[0];
      this.errorfile1 = false;
      this.error = ""; // 4000000
      if (myfile.size > 4000000) {
        this.errorfile1 = true;
        this.error = this.$t("info.invalidFileSize");
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.errorfile1) {
        this.spinner = true;
        this.disabled = true;
        let token = this.getGlobalData("accessToken");

        if (this.taskImage) {
          const filereader = new FileReader();

          filereader.onload = (event) => {
            this.uploadFile(token, event.target.result);
          };
          filereader.readAsArrayBuffer(this.taskImage);
        } else {
          this.updateAllTaskDetails(null);
        }
      }
    },
    uploadFile(token, file) {
      let groupId = "e688a8d7-824a-4483-a04c-9719828ee35d"; //Admin-crm-multi
      let filename = this.taskImage.name; // this.generateImageName(); //rename with a random number.
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/drive/items/root:/${filename}:/content`;
      axios
        .put(graphEndpoint, file, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "text/plain",
          },
        })
        .then((response) => {
          let webUrl = response.data.webUrl;
          this.updateAllTaskDetails(webUrl);
        })
        .catch((error) => {
          this.error = error;
          this.disabled = false;
          this.spinner = false;
        });
    },
    //Déplacer dans le php
    updateAllTaskDetails(webUrl) {
      let taskList = this.taskDetailsList;
      let jobData = [];

      let body = this.setBodyTaskDetails(webUrl);

      for (let i = 0; i < taskList.length; i++) {
        let taskId = taskList[i].id;
        let etag = taskList[i]["@odata.etag"];
        let obj = {
          taskId: taskId,
          etag: etag,
          body: body,
        }
        jobData.push(
          obj
        );
      }

      let scheduleJobObj = {
          request: "startTaskDetailsJob",
          jobName: "TaskDetailsUpdate",
          idRef: 0,
          jobData: jobData,
        };

      axios
        .post(this.url, scheduleJobObj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.success = true;
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    updateTaskDetails(token, taskId, body, etag) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/tasks/${taskId}/details`;
      return axios.patch(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "If-Match": etag,
        },
      });
    },
    generateImageName() {
      let characters = "a-z,0-9";
      let passwordSize = 15;

      let charactersArray = characters.split(",");
      let CharacterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }
      for (let i = 0; i < passwordSize; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }

      return password;
    },

    logError(errorList) {
      let obj = {
        request: "logError",
        jobName: "TaskDetailsModal",
        errorList: errorList,
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
